import { Checkbox, Radio, Select } from 'antd';
import { useDigitalTrapsStore } from '@features/regional-overview/digital-traps/digital-traps.zustand';
import { FLIGHT_CURVE_SIDEBAR } from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { mapTrapItemToOption } from '@features/regional-overview/digital-traps/utils';
import { When } from 'react-if';
import { useSidebar } from './sidebar.hook';
import { ViewMode } from './sidebar.model';
import css from './sidebar.module.css';
import { CheckboxDescription, CheckboxWrapper, RadioWrapper, SelectWrapper, SidebarContainer } from './sidebar.styles';

export const Sidebar = () => {
  const trapGroups = useDigitalTrapsStore(state => state.trapGroups);
  const isLoading = useDigitalTrapsStore(state => state.isLoading);
  const {
    trapOptions,
    viewModeOptions,
    handleViewModeChange,
    viewMode,
    selectedNetwork,
    handleNetworkSelect,
    selectedTraps,
    handleTrapSelect,
    t
  } = useSidebar();

  return (
    <SidebarContainer data-testid={FLIGHT_CURVE_SIDEBAR}>
      <SelectWrapper>
        <Select
          value={selectedNetwork?.id}
          onSelect={handleNetworkSelect}
          options={trapGroups.map(mapTrapItemToOption)}
          loading={isLoading}
        />
      </SelectWrapper>

      <RadioWrapper>
        <Radio.Group value={viewMode} onChange={handleViewModeChange} vertical>
          {viewModeOptions.map(option => (
            <Radio key={option.value} value={option.value} classNames={{ root: css.radioRoot, label: css.radioLabel }}>
              {option.label}
            </Radio>
          ))}
        </Radio.Group>

        <When condition={viewMode === ViewMode.COMPARE_TRAPS}>
          <CheckboxWrapper>
            <CheckboxDescription>{t('pages.regional_overview.digital_traps.select_up_to_4_traps')}</CheckboxDescription>
            <Checkbox.Group options={trapOptions} value={selectedTraps} onChange={handleTrapSelect} />
          </CheckboxWrapper>
        </When>
      </RadioWrapper>
    </SidebarContainer>
  );
};
